var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenfitGain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 36.6668H25.0003C33.3337 36.6668 36.667 33.3335 36.667 25.0002V15.0002C36.667 6.66683 33.3337 3.3335 25.0003 3.3335H15.0003C6.66701 3.3335 3.33368 6.66683 3.33368 15.0002V25.0002C3.33368 33.3335 6.66701 36.6668 15.0003 36.6668Z",
    stroke: "url(#paint0_linear_33_589)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 30.8332C27.6667 30.8332 29.1667 29.3332 29.1667 27.4998V12.4998C29.1667 10.6665 27.6667 9.1665 25.8333 9.1665C24 9.1665 22.5 10.6665 22.5 12.4998V27.4998C22.5 29.3332 23.9833 30.8332 25.8333 30.8332Z",
    stroke: "url(#paint1_linear_33_589)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 30.8335C16.0003 30.8335 17.5003 29.3335 17.5003 27.5002V21.6668C17.5003 19.8335 16.0003 18.3335 14.167 18.3335C12.3337 18.3335 10.8337 19.8335 10.8337 21.6668V27.5002C10.8337 29.3335 12.317 30.8335 14.167 30.8335Z",
    stroke: "url(#paint2_linear_33_589)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_589",
    x1: 20.0003,
    y1: 3.3335,
    x2: 20.0003,
    y2: 36.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_589",
    x1: 25.8333,
    y1: 9.1665,
    x2: 25.8333,
    y2: 30.8332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_589",
    x1: 14.167,
    y1: 18.3335,
    x2: 14.167,
    y2: 30.8335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenfitGain);
export default __webpack_public_path__ + "static/media/benfit-gain.3e9b05690dcc02243fdc6bf77c834cc0.svg";
export { ForwardRef as ReactComponent };